import React from "react"
import PropTypes from "prop-types"
import {Col} from "react-bootstrap"
import styled from "styled-components"
import {get} from "lodash"

import id from "@irati/utils/id"
import {injectIntl, FormattedMessage} from "@irati/utils/lang"
import {formatDriverName} from "@irati/insights/utils/string"
import {H3} from "@irati/ui/src/Headings"
import {Para as ParaUi} from "@irati/ui/src/Labels"
import {greys} from "@irati/ui/src/global/colors"
import padding from "@irati/ui/src/global/padding"
import {minWidthMedia} from "@irati/ui/src/global/media"
import {LatoLight} from "@irati/ui/src/global/fonts"
import isCycleCustom from "../../helpers/cycle/isCycleCustom"


const Wrapper = styled(Col)`
  display: flex;
  flex-direction: column;
  padding-top: ${padding.medium};

  ${minWidthMedia.desktop`
    padding-top: 0;
  `}
`

const StyledScoreTitle = styled(H3)`
  text-align: center;

  ${minWidthMedia.desktop`
  text-align: left;
`}
`

const Para = styled(ParaUi)`
  ${(props) => (props.medium && LatoLight)}
  color: ${greys.medium};
`

const ScoreDescription = ({averageScore, responseCount, driver, formatMessage, cycle, ...props}) => {
  const intlTitleValues = {score: averageScore.toFixed(1)}
  const lowerRange = Math.floor(averageScore)
  const upperRange = lowerRange + 1
  let driverContentIdSuffix = null
  let titleContentId = `insights.scoreDescription.overall_${lowerRange}_${upperRange}.title`
  let detailContentId = "insights.scoreDescription.overall.description"

  if (driver) {
    intlTitleValues.driver = formatDriverName(formatMessage, driver)
    driverContentIdSuffix = driver.contentId.split(".").pop()
    /**
     * @todo: umm we need to think about the analysis page when we have custom drivers */
    titleContentId = `insights.scoreDescription.driver_${lowerRange}_${upperRange}.title`
    detailContentId = `insights.scoreDescription.${driverContentIdSuffix}.description`
  }

  if (isCycleCustom(cycle)) {
    intlTitleValues.title = get(cycle, "reference")
    titleContentId = "insights.scoreDescription.title.custom"
  }

  return (
    <Wrapper id={id("ScoreDescription", props)} xs={12} md={8}>
      <StyledScoreTitle small>
        <FormattedMessage
          id={titleContentId}
          values={intlTitleValues} />
      </StyledScoreTitle>
      {!isCycleCustom(cycle) && (
        <Para medium small>
          <FormattedMessage id={detailContentId} />
        </Para>
      )}
    </Wrapper>
  )
}

ScoreDescription.propTypes = {
  averageScore: PropTypes.number.isRequired,
  responseCount: PropTypes.number.isRequired,
  formatMessage: PropTypes.func.isRequired,
  driver: PropTypes.object,
  cycle: PropTypes.object
}
ScoreDescription.defaultProps = {
  driver: null,
  cycle: {}
}
export default injectIntl(ScoreDescription)
